import { Mark, mergeAttributes, markInputRule, markPasteRule } from '@tiptap/core';
var inputRegex = /(?:^|\s)((?:==)((?:[^~=]+))(?:==))$/;
var pasteRegex = /(?:^|\s)((?:==)((?:[^~=]+))(?:==))/g;
var Highlight = Mark.create({
  name: 'highlight',
  addOptions: function addOptions() {
    return {
      multicolor: false,
      HTMLAttributes: {}
    };
  },
  addAttributes: function addAttributes() {
    if (!this.options.multicolor) {
      return {};
    }

    return {
      color: {
        default: null,
        parseHTML: function parseHTML(element) {
          return element.getAttribute('data-color') || element.style.backgroundColor;
        },
        renderHTML: function renderHTML(attributes) {
          if (!attributes.color) {
            return {};
          }

          return {
            'data-color': attributes.color,
            style: "background-color: ".concat(attributes.color, "; color: inherit")
          };
        }
      }
    };
  },
  parseHTML: function parseHTML() {
    return [{
      tag: 'mark'
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['mark', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this = this;

    return {
      setHighlight: function setHighlight(attributes) {
        return function (_ref2) {
          var commands = _ref2.commands;
          return commands.setMark(_this.name, attributes);
        };
      },
      toggleHighlight: function toggleHighlight(attributes) {
        return function (_ref3) {
          var commands = _ref3.commands;
          return commands.toggleMark(_this.name, attributes);
        };
      },
      unsetHighlight: function unsetHighlight() {
        return function (_ref4) {
          var commands = _ref4.commands;
          return commands.unsetMark(_this.name);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this2 = this;

    return {
      'Mod-Shift-h': function ModShiftH() {
        return _this2.editor.commands.toggleHighlight();
      }
    };
  },
  addInputRules: function addInputRules() {
    return [markInputRule({
      find: inputRegex,
      type: this.type
    })];
  },
  addPasteRules: function addPasteRules() {
    return [markPasteRule({
      find: pasteRegex,
      type: this.type
    })];
  }
});
export { Highlight, Highlight as default, inputRegex, pasteRegex };